module.exports = __webpack_public_path__ + "img/v1-sector.5c42fb9d.png";